import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';
import i18n from 'i18n';
import { noop } from 'lodash';
import { FocusableParent } from 'components/navigation';

const StyledWrapper = styled.div`
  width: ${scaleSize(1500)}px;
  height: ${scaleSize(1080)}px;
  margin-left: ${scaleSize(220)}px;
  display: table;
`;

const StyledContent = styled(FocusableParent)`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  color: ${({ theme }) => theme.iconDefaultColor};

  svg {
    width: ${scaleSize(192)}px;
    height: ${scaleSize(192)}px;
  }
`;

const StyledBottom = styled(Button)`
  margin: ${scaleSize(50)}px 0 0;
`;

export const StubLoginToProceed = props => {
  const { onLoginEnter, children } = props;

  return (
    <StyledWrapper>
      <StyledContent defaultSection>
        <div>{children}</div>
        <StyledBottom onEnter={onLoginEnter}>{i18n.t('common.login')}</StyledBottom>
      </StyledContent>
    </StyledWrapper>
  );
};

StubLoginToProceed.defaultProps = {
  onLoginEnter: noop,
};

StubLoginToProceed.propTypes = {
  onLoginEnter: PropTypes.func,
};
